import React from "react";
import { Button, ButtonLoader } from "@sscs/ui";
import { DownloadIcon as GetAppIcon } from "@sscs/ui/icons";
const ExportButton = ({ id, text, onClick, isDisabled = false, }) => {
    return (React.createElement(Button, { id: id, color: "secondary", endIcon: isDisabled ? React.createElement(ButtonLoader, null) : React.createElement(GetAppIcon, null), onClick: onClick, size: "small", disabled: isDisabled }, text));
};
export default ExportButton;
//# sourceMappingURL=ExportButton.js.map